import React, {useEffect, useState} from 'react';
import {
    IonPage,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton, IonSelect, IonSelectOption, useIonAlert, IonLoading, IonAlert
} from '@ionic/react';
import appLogo from "../theme/images/logo-big.png";
import {useHistory} from "react-router";
import {actionToSendOtp, actionToVerifyOtpAndSaveData} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

const RegisterPage = ({renderHeaderPage}) => {
    const history = useHistory();
    const {setSignupSigninError,getOtpRequest,getOtpSuccess,signupSigninError,userOtpDetails,otpValidationError, setOtpValidationError} = useStore();
    const [resent, setResent] = useState(false);
    const [showOtpAlertPopup, setShowOtpAlertPopup] = useState(false);
    const [presentAlert] = useIonAlert();
    const [form, setForm] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        refNo: '',
        designation: 'ca_member',
        dynamicField: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const validate = () => {
        const err = {};

        if (!form.name.trim()) err.name = 'Name is required';
        if (!form.email.match(/^\S+@\S+\.\S+$/)) err.email = 'Valid email required';
        if (form.password.length < 8) err.password = 'Password must be at least 8 characters';
        if (form.password !== form.confirmPassword) err.confirmPassword = 'Passwords do not match';
        if (!form.mobile.match(/^\d{10}$/)) err.mobile = 'Enter 10 digit mobile number';
        if (!form.dynamicField.trim()) err.dynamicField = 'This field is required';

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = () => {
        if (validate()) {
            actionToSendOtp(form,setSignupSigninError,getOtpRequest,getOtpSuccess);
        }
    };

    const handleResendOtp = () => {
        setResent(true);
        actionToSendOtp(form, setSignupSigninError, getOtpRequest, getOtpSuccess);
    };

    const handleSubmitOtp = (data) => {
        const enteredOtp = data.otp;
        actionToVerifyOtpAndSaveData(form, enteredOtp);
    };


    const showOtpAlert = () => {
        setShowOtpAlertPopup(true);
    };

    useEffect(()=>{
        if(otpValidationError){
            presentAlert({
                header: 'OTP Verification fail',
                message: 'You have entered wrong otp.',
                buttons: [{
                    text: 'Ok',
                    handler: ()=>{
                        setOtpValidationError(false);
                    },
                }],
            });
        }
    },[otpValidationError])

    const getDynamicLabel = () => {
        switch (form.designation) {
            case 'ca_member':
                return 'ICAI Membership No';
            case 'ca_student':
                return 'ICAI Student Regn. No';
            case 'other_professional':
                return 'ICSI / ICMA / Bar Council Membership No';
            case 'accountant_other':
                return 'PAN No';
            default:
                return '';
        }
    }

    const goToPage = (page)=>{
        history.replace(page);
    }

    useEffect(()=>{
        if (signupSigninError?.error && signupSigninError?.message){
            if (signupSigninError?.error === 'phone'){
                const errs = {};
                errs.emailOrPhone = signupSigninError?.message;
                setErrors(errs);
            } else {
                const errs = {};
                errs.password = signupSigninError?.message;
                setErrors({...errs});
            }
            presentAlert({
                header: 'Registration Failed!',
                message: signupSigninError?.message,
                buttons: [{
                    text: 'Ok'
                }],
            });
        }else{
            setErrors({});
        }
    },[signupSigninError])

    useEffect(()=>{
        if (!userOtpDetails?.loading && userOtpDetails?.success){
            showOtpAlert();
        }
    },[userOtpDetails])

    useEffect(()=>{
        setForm({
            name: '',
            email: '',
            password: '',
            confirmPassword: '',
            mobile: '',
            refNo: '',
            designation: 'ca_member',
            dynamicField: ''
        })
        setShowOtpAlertPopup(false)
        setSignupSigninError({});
    },[])

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="register-content">
                <IonGrid className="register-grid">
                    <IonRow>
                        <IonCol size="12" className="ion-text-center">
                            <img src={appLogo} alt="CA World" className="register-logo" />
                        </IonCol>

                        {/* Name & Email */}
                        <IonCol size="12" sizeMd="12">
                            <div className="form-group">
                                <label className="form-label">Name</label>
                                <input
                                    className="form-input"
                                    value={form.name}
                                    onChange={(e) => handleChange('name', e.target.value)}
                                    placeholder="Full Name"
                                />
                                {errors.name && <p className={"danger_error_text"} color="danger">{errors.name}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12" sizeMd="12">
                            <div className="form-group">
                                <label className="form-label">Email Address</label>
                                <input
                                    className="form-input"
                                    value={form.email}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                    placeholder="Email"
                                />
                                {errors.email && <p className={"danger_error_text"} color="danger">{errors.email}</p>}
                                {errors.emailOrPhone && <p className={"danger_error_text"} color="danger">{errors.emailOrPhone}</p>}
                            </div>
                        </IonCol>

                        {/* Password & Confirm */}
                        <IonCol size="12" sizeMd="6">
                            <div className="form-group">
                                <label className="form-label">Password</label>
                                <input
                                    type="password"
                                    className="form-input"
                                    value={form.password}
                                    onChange={(e) => handleChange('password', e.target.value)}
                                    placeholder="Password (min 8 characters)"
                                />
                                {errors.password && <p className={"danger_error_text"} color="danger">{errors.password}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12" sizeMd="6">
                            <div className="form-group">
                                <label className="form-label">Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-input"
                                    value={form.confirmPassword}
                                    onChange={(e) => handleChange('confirmPassword', e.target.value)}
                                    placeholder="Confirm Password"
                                />
                                {errors.confirmPassword && <p className={"danger_error_text"} color="danger">{errors.confirmPassword}</p>}
                            </div>
                        </IonCol>

                        {/* Mobile & Ref No */}
                        <IonCol size="12" sizeMd="12">
                            <div className="form-group">
                                <label className="form-label">Mobile</label>
                                <input
                                    type="tel"
                                    className="form-input"
                                    value={form.mobile}
                                    onChange={(e) => handleChange('mobile', e.target.value)}
                                    placeholder="10-digit Mobile Number"
                                />
                                {errors.mobile && <p className={"danger_error_text"} color="danger">{errors.mobile}</p>}
                            </div>
                        </IonCol>

                        <IonCol size="12" sizeMd="12">
                            <div className="form-group">
                                <label className="form-label">Ref No. (optional)</label>
                                <input
                                    className="form-input"
                                    value={form.refNo}
                                    onChange={(e) => handleChange('refNo', e.target.value)}
                                    placeholder="Reference Number"
                                />
                            </div>
                        </IonCol>

                        {/* Designation */}
                        <IonCol size="12" sizeMd={6}>
                            <div className="form-group">
                                <label className="form-label">Designation</label>
                                <IonSelect
                                    className="form-input ion-slide-select"
                                    value={form.designation}
                                    onIonChange={(e) => handleChange('designation', e.detail.value)}
                                    interface="action-sheet"
                                    placeholder="Select your designation"
                                >
                                    <IonSelectOption value="ca_member">CA Member</IonSelectOption>
                                    <IonSelectOption value="ca_student">CA Student / CA Finalist</IonSelectOption>
                                    <IonSelectOption value="other_professional">Other Professional</IonSelectOption>
                                    <IonSelectOption value="accountant_other">Accountants / Others</IonSelectOption>
                                </IonSelect>
                            </div>
                        </IonCol>

                        {/* Dynamic Field */}
                        <IonCol size="12" sizeMd="6">
                            <div className="form-group">
                                <label className="form-label">{getDynamicLabel()}</label>
                                <input
                                    className="form-input"
                                    value={form.dynamicField}
                                    onChange={(e) => handleChange('dynamicField', e.target.value)}
                                    placeholder={getDynamicLabel()}
                                />
                                {errors.dynamicField && <p className={"danger_error_text"} color="danger">{errors.dynamicField}</p>}
                            </div>
                        </IonCol>

                        {/* Submit */}
                        <IonCol size="12" className="ion-text-center">
                            <IonButton expand="block" className="register-button" onClick={handleSubmit}>
                                Register
                            </IonButton>

                            <p className="login-link-text or-sec">OR</p>

                            <p className="login-text">
                                Already have an account? <a onClick={() => goToPage('/login')}
                                                            className="login-link">Login</a>
                            </p>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>


            {/*///// OTP ALERT MODAL /////////*/}
            <IonAlert
                isOpen={showOtpAlertPopup}
                onDidDismiss={() => setShowOtpAlertPopup(false)}
                header="OTP Sent"
                message={
                    resent
                        ? 'OTP has been resent to your email.'
                        : 'Please enter the OTP sent to your email.'
                }
                inputs={[
                    {
                        name: 'otp',
                        type: 'number',
                        placeholder: 'Enter OTP',
                    },
                ]}
                buttons={[
                    {
                        text: 'Resend OTP',
                        handler: () => {
                            handleResendOtp();
                            return false;
                        },
                    },
                    {
                        text: 'Submit',
                        handler: (data) => {
                            handleSubmitOtp(data);
                            return false;
                        },
                    },
                ]}
            />
            {/*///// OTP ALERT MODAL /////////*/}

            <IonLoading isOpen={userOtpDetails?.loading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    );
};

export default RegisterPage;
